module.exports = __webpack_public_path__ + "img/brandskipdawg.132918a5.jpg";